var map = {
	"./canvasimg.png": 2714,
	"./default.png": 1836,
	"./editorDeteleIcon.svg": 130,
	"./fullscreen.png": 9536,
	"./img-1.png": 2364,
	"./img-2.png": 471,
	"./img-3.png": 1246,
	"./inspection-one.png": 8430,
	"./overRidden.png": 7415,
	"./profile.png": 5572,
	"./unidentified.png": 6069,
	"./user.png": 5314,
	"./viewIcon.png": 6511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;